module.exports = __webpack_public_path__ + "img/Bankston.e8737680.svg";